import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Flow } from 'types';
import { buildFlowPath } from 'utils/flowNavigation';
import { Button } from '../ui/button';
import { Card, CardContent, CardTitle } from '../ui/card';

export interface InvalidFlowProps {
  flow: Flow;
  courseId?: number | null;
}

export const InvalidFlow: React.FC<InvalidFlowProps> = ({ flow, courseId = null }) => {
    const navigate = useNavigate();

    const handleContinue = useCallback(() => {
      if (flow.name) {
        navigate(buildFlowPath({ flowName: flow.name, courseId }));
        return;
      }

      navigate('/home');
    }, [courseId, flow.name, navigate]);

    return (
      <main className="flex min-h-[calc(100vh-120px)] items-center justify-center px-4 py-6">
        <Card maxWidth="narrow" className="w-full max-w-md">
          <CardTitle
            centered={true}
            title={
              <p className="leading-tight">
                Complete the previous lesson first
              </p>
            }
            subtitle={`You need to complete ${flow.title || flow.name} first.`}
          />

          <CardContent variant="custom" className="pt-4 flex flex-col items-center gap-3">
            <Button
              variant="default"
              onClick={handleContinue}
              size="auto"
              disabled={!Boolean(flow.name)}
            >
              Continue lesson
            </Button>
            <Button variant="secondary" onClick={() => navigate(courseId ? `/training?courseId=${courseId}#courses` : '/training#courses')} size="auto">
              Back to course outline
            </Button>
          </CardContent>
        </Card>
      </main>
    );
};
